import { ButtonSecondary } from "components/Atoms/Button";
import MultiLinkedArtistList from "components/Picker/ArtistPicker/MultiLinkedArtistList";
import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedArtistsPanel } from "./LinkedArtistsPanel";
import { LinkedPanelMessage } from "components/linkedBookkeepings/LinkedPanelMessage";

interface Props {
  webformId: number;
  formUrl: string;
}

export const LinkedArtistsWebformPanel = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddArtists = async (newArtists: server.dto.ArtistSmall[]) => {
    await window.CoreApi.WebformConfiguration.LinkArtists({
      webformId: props.webformId,
      artistIds: newArtists.map(a => a.artistId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkArtist = async (artist: server.dto.ArtistForList) => {
    await window.CoreApi.WebformConfiguration.UnlinkArtists({
      webformId: props.webformId,
      artistIds: [artist.artistId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedArtistsPanel<server.dto.ListLinkedArtistToWebformInstruction>
      renderLastColumn={(artist) =>
        <ButtonSecondary label={RESX.Webform.PreviewForm} onClick={() => window.open(`${props.formUrl}&artist=${artist.artistId}`)} />}
      renderLinkedArtistPanelMessage={(selected, total, onAddAll) => <LinkedPanelMessage
        selected={selected}
        total={total}
        onAddAll={onAddAll}
        nothingSelectedMessage={RESX.Artist.AssignAtLeastOneArtist}
        entityName={site.currentEnvironment.functionGroups.artist.plural}
      />}
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={site.currentEnvironment.functionGroups.artist.plural}
      listFunc={window.CoreApi.WebformConfiguration.PaginatedLinkedArtists}
      initialInstruction={{
        webformId: props.webformId,
        whereInOrNotIn: "in",
        keyword: "",
        page: 1,
        perPage: 8,
      }}
      onDelete={unlinkArtist}
      onAdd={() => setIsNewModalOpen(true)}
      onRemoveAll={() => window.CoreApi.WebformConfiguration.UnlinkAllForWebform(props.webformId)}
      onAddAll={() => window.CoreApi.WebformConfiguration.LinkAllForWebform(props.webformId)}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.artist.plural}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddArtists}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedArtistList
        initialInstruction={{
          webformId: props.webformId,
          whereInOrNotIn: "notIn",
          keyword: "",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.WebformConfiguration.PaginatedLinkedArtists}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
};